import React from 'react';

import {
  formatDate,
  ProductTypeDisplayT,
  today,
} from '@consumer-frontend/nc-utils';

import { NcContractPDF } from '../NcContractPDF';
import { NcFeeSaverBanner } from '../NcFeeSaverBanner';

import '@consumer-bootstrap/brands/netcredit/contract/contract-header.scss';
import '@consumer-bootstrap/netcredit.scss';

export type NcContractHeaderPropsT = {
  accountId: string;
  loanNumber: string;
  productTypeDisplay: ProductTypeDisplayT;
  showFeeSaverBanner: boolean;
};
export type NcContractHeaderT = React.FC<NcContractHeaderPropsT>;

export const NcContractHeader: NcContractHeaderT = ({
  accountId,
  loanNumber,
  productTypeDisplay,
  showFeeSaverBanner,
}) => {
  const currentDate = formatDate(today());

  return (
    <div className="contract-header-container">
      <div className="contract-header">
        <div className="contract-header-details">
          <h2 className="h3">{productTypeDisplay} Loan Agreement</h2>
          <p data-chromatic="ignore">{currentDate}</p>
        </div>
        <NcContractPDF accountId={accountId} loanNumber={loanNumber} />
      </div>
      {showFeeSaverBanner && <NcFeeSaverBanner />}
    </div>
  );
};
